import { useState, useEffect } from 'react';
import Logo from "../../assets/main_logo.jpg";
import { Home, Search, Pill, ShoppingCart, FileText } from 'lucide-react';
import { logoutUser, usePreviousPath } from '../../utils/helpers';

export default function NotFound404() {
  const prevPath = usePreviousPath();

  const floatingPills = Array.from({ length: 6 }, (_, i) => (
    <div
      key={i}
      className={`absolute w-4 h-6 bg-gradient-to-b from-blue-400 to-blue-600 rounded-full opacity-20 animate-bounce`}
      style={{
        left: `${10 + i * 15}%`,
        top: `${20 + (i % 3) * 10}%`,
        animationDelay: `${i * 0.3}s`,
        animationDuration: `${2 + i * 0.2}s`
      }}
    />
  ));

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50 flex items-center justify-center p-4 relative overflow-hidden">
      
      {/* Floating Pills Background */}
      {floatingPills}
      
      {/* Main Content Container */}
      <div className="text-center max-w-lg mx-auto relative z-10">
        
        {/* Logo/Brand */}
        <div className="mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-blue-600 to-green-600 rounded-full shadow-lg mb-4">
            <img src={Logo} className=" text-white" />
          </div>
          <h1 className="text-2xl font-bold text-gray-800 tracking-wide">LifeChemist</h1>
          <p className="text-sm text-gray-600 mt-1">Pharmacy Management System</p>
        </div>

        {/* 404 Display */}
        <div className="mb-8">
          <div className="flex items-center justify-center space-x-4 mb-4">
            <div className="text-8xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-green-600">
              4
            </div>
            <div className="relative">
              <div className="w-16 h-16 border-4 border-blue-200 rounded-full"></div>
              <div className="absolute inset-0 w-16 h-16 border-4 border-blue-600 rounded-full animate-spin border-t-transparent"></div>
              <Pill className="absolute inset-4 w-8 h-8 text-blue-600" />
            </div>
            <div className="text-8xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-green-600">
              4
            </div>
          </div>
          
          <h2 className="text-3xl font-bold text-gray-800 mb-2">Page Not Found</h2>
          
        </div>

        {/* Error Message */}
        <div className="bg-white rounded-lg shadow-lg p-6 mb-8 border-l-4 border-blue-500">
          <div className="flex items-start">
            <FileText className="w-5 h-5 text-blue-500 mt-1 mr-3" />
            <div className="text-left">
              <h3 className="font-semibold text-gray-800 mb-1">What happened?</h3>
              <p className="text-sm text-gray-600">
                The page you're looking for might have been moved, deleted, or the URL was entered incorrectly.
              </p>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
            {prevPath === "/" ? (
                <button
                    onClick={logoutUser}
                    className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-lg hover:from-blue-700 hover:to-blue-800 transition-all duration-200 shadow-md hover:shadow-lg transform hover:scale-105"
                >
                    <Home className="w-5 h-5 mr-2" />
                    Logout
                </button>    
            ):(
            <button
                onClick={() => window.history.back()}
                className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-lg hover:from-blue-700 hover:to-blue-800 transition-all duration-200 shadow-md hover:shadow-lg transform hover:scale-105"
            >
                <Home className="w-5 h-5 mr-2" />
                Go Back
            </button>
            )}
          
          
        </div>

        {/* Quick Links */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-500 mb-4">Quick Links:</p>
          <div className="flex flex-wrap justify-center gap-4 text-sm">
            <a href="/dashboard" className="text-blue-600 hover:text-blue-800 flex items-center">
              <Home className="w-4 h-4 mr-1" />
              Dashboard
            </a>
            <a href="/inventory" className="text-blue-600 hover:text-blue-800 flex items-center">
              <Pill className="w-4 h-4 mr-1" />
              Inventory
            </a>
            <a href="/orders" className="text-blue-600 hover:text-blue-800 flex items-center">
              <ShoppingCart className="w-4 h-4 mr-1" />
              Orders
            </a>
            <a href="/search" className="text-blue-600 hover:text-blue-800 flex items-center">
              <Search className="w-4 h-4 mr-1" />
              Search
            </a>
          </div>
        </div>
      </div>

      {/* Bottom decoration */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-blue-100 to-transparent opacity-50"></div>
    </div>
  );
}